module.exports = __webpack_public_path__ + "static/media/blog6-image.3b356089.jpg";